import React, { useContext, useEffect, useState } from 'react'
import { Alert, Button, DatePicker, Form, Input, Layout, Menu, message, Tabs, TabsProps } from 'antd'
import { getRequestAuth, postRequestAuth, putRequestAuth } from '../../../request/request';
import moment from 'moment';
import { AppContext } from '../../../App';
import { ContextType } from '../../../type/type';
import { useTranslation } from 'react-i18next';
import validatorServerErrors from '../../../modules/ValidatorServerErrors/ValidatorServerErrors';
import { JWT, ME } from '../../../reduser/Reduser';
import { useLocation, useNavigate } from 'react-router-dom'
import { validateAge } from '../../../function/validateAge';
import '../style/styleProfile.scss'
import BottomMenuInfo from '../../../modules/BottomMenuInfo/BottomMenuInfo';

type FieldType = {
  username?: string
  password?: string
  remember?: string
}

const Email = () => {
  const { state, dispatch, isMobileWidth } = useContext<ContextType>(AppContext)
  const { t } = useTranslation()
  const [about_me] = Form.useForm();
  const [form_phone] = Form.useForm()
  const [form_email] = Form.useForm()
  const [form_password] = Form.useForm()
  const [form_change_phone] = Form.useForm()
  const [userId, setUserId] = useState(null)
  const [dateBirthday, setDateBirthday] = useState(null)
  const [userPhone, setUserPhone] = useState(null)
  const [reload, setReload] = useState(false)
  const [validateErrors, setValidateErrors]: any = useState({})
  const [isLoading, setLoading] = useState(false)
  const [step, setStep] = useState(1)
  const dateFormat = 'YYYY-MM-DD'
  const dateFormatCalendar = ['YYYY-MM-DD', 'DD.MM.YYYY']
  const navigate = useNavigate()

  useEffect(() => {
    getRequestAuth('/profile/about_me/')
      .then((res: any) => {
        const {
          first_name,
          last_name,
          middle_name,
          date_birthday,
          user: { id, phone, email },
        } = res?.data || {}

      const newDate: any = moment(date_birthday, dateFormat)

      setUserId(id)
      setDateBirthday(date_birthday)

      about_me.setFieldsValue({
        first_name,
        last_name,
        middle_name,
        date_birthday: date_birthday ? newDate : '',
      })

      form_email.setFieldsValue({
        email,
      })

      setUserPhone(phone)
      form_phone.setFieldsValue({
        phone,
      })
    })
    .catch((err) => {
      validatorServerErrors(err.data)
      dispatch({
        type: JWT,
        payload: null,
      })
      navigate('/cabinet')
    })
  }, [reload, state.lang])

  const onFinishFailed = (errorInfo: any) => {
    console.log('errorInfo', errorInfo)
  }

  const disabledDate = (current: any) => {
    const minDate = new Date(1900, 0, 1)
    const maxDate = moment()
    return current && (current < minDate || current > maxDate)
  }

  const convertDate = (value: any) => {
    return moment(value).format(dateFormat)
  }
    
  const onFinish = (values: any, type: string) => {
    console.log(type)
    setLoading(true)
  
    if (type === 'form_email') {
      delete values.email

      postRequestAuth('/profile/change_email/', values)
        .then((res) => {
          message.success(res?.data?.status)
          setLoading(false)
          // removeCookiesWithRetries({
          //   cookieNames: ['jwt', 'refresh'],
          //   maxRetries: 10,
          //   delay: 100,
          //   cookies,
          //   removeCookie,
          //   navigate,
          //   dispatch,
          // })
          // navigate('/')
        })
        .catch((err) => {
          setLoading(false)
          validatorServerErrors(err.data, setValidateErrors)
        })
    }
    }

  return (
    <>
     { isMobileWidth && <h3 className='profile-title'>{t('h78')}</h3> }
     <Form
        form={form_email}
        name="basic"
        layout="vertical"
        initialValues={{ remember: true }}
        onFinish={(e) => onFinish(e, 'form_email')}
        onFinishFailed={onFinishFailed}
        autoComplete="off"
      >
        <Form.Item<FieldType>
          label={t('h49')}
          name="email"
          rules={[{ required: true, type: 'email', message: `${t('h48')} ${t('h49')}` }]}
          validateStatus={validateErrors?.new_email ? 'error' : ''}
           help={validateErrors?.new_email}
        >
          <Input disabled />
        </Form.Item>
          {step === 2 && (
            <>
              <Form.Item<FieldType>
                label={t('h86')}
                name="new_email"
                rules={[{ required: true, type: 'email', message: `${t('h48')} ${t('h49')}` }]}
                validateStatus={validateErrors?.new_email ? 'error' : ''}
                help={validateErrors?.new_email}
              >
                <Input />
              </Form.Item>
      
              <Form.Item<FieldType>
                label={t('h54')}
                name="password"
                rules={[{ required: true, message: `${t('h48')} ${t('h54')}` }]}
                validateStatus={validateErrors?.password ? 'error' : ''}
                help={validateErrors?.password}
              >
                <Input.Password />
              </Form.Item>
      
              <div className="text-center">
                <Button
                  type="primary"
                  htmlType="submit"
                  loading={isLoading}
                  className={ isMobileWidth ? 'mobile-button-submit' : 'color_btn'}>
                    {t('h81')}
                </Button>
              </div>
            </>
          )}
      
          {step === 1 && (
            <div className="text-center">
              <Button
                type="primary"
                onClick={() => setStep(2)}
                className={ isMobileWidth ? 'mobile-button-submit' : 'color_btn'}>
                  {t('h85')}
              </Button>
            </div>
          )}
        </Form>
        { isMobileWidth && <BottomMenuInfo type="man" /> }
    </>
  )
}

export default Email
